import * as React from "react";

function PopUpIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 14L8 8.5"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 8.5H8"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.5V8.5"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4386 1.51904H10.0526C9.74985 1.51904 9.50439 1.76664 9.50439 2.07206V6.49623C9.50439 6.80166 9.74985 7.04925 10.0526 7.04925H14.4386C14.7414 7.04925 14.9869 6.80166 14.9869 6.49623V2.07206C14.9869 1.76664 14.7414 1.51904 14.4386 1.51904Z"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8409 10.8255V13.5132C12.8409 14.1215 12.3475 14.6193 11.7444 14.6193H2.97247C2.3694 14.6193 1.87598 14.1215 1.87598 13.5132V4.66488C1.87598 4.05656 2.3694 3.55884 2.97247 3.55884H5.9933"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PopUpIcon;
